export default __webpack_public_path__ + "static/media/precription-card-icon.c4f40dde.svg";